import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

type LoaderProps = {
    className?: string
}

export const Loader = ({ className }: LoaderProps) => (
    <div className={cn('flex h-full flex-col items-center justify-center gap-4', className)}>
        <Loader2 className='h-12 w-12 animate-spin text-green-300' />
        <p className='text-gray-600'>Cargando...</p>
    </div>
)
